// extracted by mini-css-extract-plugin
export var dividerContainer = "_5s-0";
export var line = "_5s-1";